/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocIcon24Solid = forwardRef('DocIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.05 2H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-7.95h-5.2a2.75 2.75 0 0 1-2.75-2.75V2Z" }),
        React.createElement("path", { d: "M20 8.55v-.04l-6.45-6.45V7.3c0 .69.56 1.25 1.25 1.25H20Z" })));
});
